module.exports = __webpack_public_path__ + "static/media/Medium_Bell_Ringing_Near.0328f8c8.mp3";